module.exports = __webpack_public_path__ + "static/media/__hands.abeb2288.svg";